var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveOpsPrioritiesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 1.33325V3.33325",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 1.33325V3.33325",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14 5.66659V9.08659C13.4067 8.61326 12.6533 8.33325 11.8333 8.33325C11.0133 8.33325 10.2467 8.6199 9.64667 9.10657C8.84 9.7399 8.33333 10.7333 8.33333 11.8333C8.33333 12.4866 8.52001 13.1133 8.84001 13.6333C9.08667 14.0399 9.40666 14.3933 9.78666 14.6666H5.33333C3 14.6666 2 13.3333 2 11.3333V5.66659C2 3.66659 3 2.33325 5.33333 2.33325H10.6667C13 2.33325 14 3.66659 14 5.66659Z",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66675 7.33325H8.66675",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66675 10.6667H6.41341",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 11.8333C15.3333 12.4866 15.1466 13.1133 14.8266 13.6333C14.6399 13.9533 14.4066 14.2333 14.1333 14.4599C13.5199 15.0066 12.7199 15.3333 11.8333 15.3333C11.0666 15.3333 10.3599 15.0866 9.78658 14.6666C9.40658 14.3933 9.08659 14.0399 8.83993 13.6333C8.51993 13.1133 8.33325 12.4866 8.33325 11.8333C8.33325 10.7333 8.83992 9.7399 9.64659 9.10657C10.2466 8.6199 11.0133 8.33325 11.8333 8.33325C12.6533 8.33325 13.4066 8.61326 13.9999 9.08659C14.8133 9.72659 15.3333 10.7199 15.3333 11.8333Z",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5001 10.4263C12.5001 10.1501 12.2762 9.92627 12.0001 9.92627C11.7239 9.92627 11.5001 10.1501 11.5001 10.4263V11.5001H10.4263C10.1501 11.5001 9.92627 11.7239 9.92627 12.0001C9.92627 12.2762 10.1501 12.5001 10.4263 12.5001H11.5001V13.5738C11.5001 13.85 11.7239 14.0738 12.0001 14.0738C12.2762 14.0738 12.5001 13.85 12.5001 13.5738V12.5001H13.5738C13.85 12.5001 14.0738 12.2762 14.0738 12.0001C14.0738 11.7239 13.85 11.5001 13.5738 11.5001H12.5001V10.4263Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveOpsPrioritiesIcon);
export default __webpack_public_path__ + "d6438e940066c870806c8dee8d739ba4.svg";
export { ForwardRef as ReactComponent };